import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Loader;
import Loadable from "../../Loadable";
import Loader from "./ui/Loader";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyShoppingCartPopup = function LazyShoppingCartPopup(props) {
  return /*#__PURE__*/_jsx(Loadable, _objectSpread({
    Loader: _Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {})),
    module: function module() {
      return import(/* webpackChunkName: "shopping-cart-popup" */"./containers/WithProductsContext");
    }
  }, props));
};
export default LazyShoppingCartPopup;